import constants from './_constants.js';

export default (timezone) => {
  if (!timezone || typeof timezone !== 'string') {
    console.warn(`Invalid timezone "${timezone}" provided, using default "${constants.DEFAULT_TIMEZONE}"`);

    return constants.DEFAULT_TIMEZONE;
  }

  if (typeof Intl !== 'undefined' && Intl.supportedValuesOf) {
    const supportedTimezones = Intl.supportedValuesOf('timeZone');
    const isValid = supportedTimezones.includes(timezone);

    if (isValid) {
      return timezone;
    }

    console.warn(`Invalid timezone "${timezone}" provided, using default "${constants.DEFAULT_TIMEZONE}"`);
    return constants.DEFAULT_TIMEZONE;
  }

  console.warn(`Intl is not supported, using default "${constants.DEFAULT_TIMEZONE}"`);
  return constants.DEFAULT_TIMEZONE;
};
